module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAaCAMAAABrajdMAAAAWlBMVEUAAAD/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th7/th61GWCeAAAAHXRSTlMA1QT5CuR8YlFLIRSM8+/czMi/qaWVd2dcV0Q2MRtrMY4AAAB7SURBVCjPhZJXDsAgDENLoXvv6ftfs1UnEATv0wZknHjh7hlZ0adGowHPM4OeAChHQY0aJ0Hk63qMC5boBsNNu6n6gpdOieYzvPBBjjbjpwjFf6GCRDB90SIosPjRBYdKbjtP37fnofnpfx390D5p/8550fm694Hsj4MDPHEW9aS3bWEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/otherRight.png
// module id = R1Gk
// module chunks = 1